import { Component } from '@angular/core';

import { environment } from '@env/environment';

@Component({
  selector: 'app-electron-deprecation-warning',
  templateUrl: './electron-deprecation-warning.component.html',
  styleUrls: ['./electron-deprecation-warning.component.scss'],
  standalone: false
})
export class ElectronDeprecationWarningComponent {
  readonly isElectron = environment.electron;
  readonly hsmBridgeDownloadUrl = environment.hsmBridgeDownloadUrl;
  readonly webDocumentsUrl = `${environment.panelUrl}/documentos`;
}
